"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.broadcast = broadcast;
var _types = require("../../actions/broadcast/types");
var initialState = {
  endpoints: [],
  recordings: []
};
function broadcast() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.GET_BROADCAST, "_SUCCESS")) {
    return action.payload;
  }
  return state;
}